import * as React from "react";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import LoadingFullScreen from "../../../components/LoadingFullScreen";
import { RootState } from "../../types";
import { scheduleVideoChat } from "../actions";
import ScheduleVideoChat from "../components/ScheduleVideoChat";
import { Patient } from "../../patient/types";

interface StoreProps {
  loading: boolean;
  patient: Patient | null;
}

interface DispatchProps {
  scheduleVideoChat: (file: FormData) => void;
}

interface OwnState {
  isBusy: boolean;
}

type Props = OwnState & DispatchProps & StoreProps & RouteComponentProps;

class ScheduleVideoChatContainer extends React.PureComponent<Props, OwnState> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      isBusy: false
    };
  }

  public render() {
    const { loading, patient, scheduleVideoChat } = this.props;
    return (
      <>
        {loading && <LoadingFullScreen />}
        <ScheduleVideoChat scheduleVideoChat={scheduleVideoChat} patient={patient} />
      </>
    );
  }
}

export default connect<StoreProps, DispatchProps, {}, RootState>(
  state => ({
    loading: state.dashboard.loading,
    patient: state.patientdetail.data.patient
  }),
  {
    scheduleVideoChat
  }
)(ScheduleVideoChatContainer);
